import { Button } from '@mui/material';
import useResyncProjects from 'app/hooks/use-resync-projects';

export default function ProjectListActionsRight({ toggleCreateNewProject }: {toggleCreateNewProject: () => void}) {
	const reSyncAll = useResyncProjects();

	return (
		<>
			{/* TODO: Move to separate component for web and desktop*/}
			<Button
				color="secondary"
				onClick={reSyncAll}
				sx={!!reSyncAll ? { display: 'none' } : {}}>
				Sync projects
			</Button>
			<Button onClick={toggleCreateNewProject}>Add</Button>
		</>
	);
}
